import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchShoppingLists, updateShoppingList } from "../services/shoppingListService";
import { UserContext } from "./UserContext";

export const ShoppingListContext = createContext();

export const ShoppingListProvider = ({ children }) => {
  const [generatedItems, setGeneratedItems] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useContext(UserContext);
  const userId = user?.uid;

  useEffect(() => {
    if (!userId) return;

    const loadShoppingLists = async () => {
      try {
        setLoading(true);
        const data = await fetchShoppingLists(userId);
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadShoppingLists();
  }, [userId]);

  const updateItem = (index, updatedItem) => {
    const updatedItems = [...items];
    updatedItems[index] = updatedItem;
    setItems(updatedItems);
    saveItems(updatedItems);
  };

  const deleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
    saveItems(updatedItems);
  };

  const saveItems = async (updatedItems) => {
    if (!userId) return;

    try {
      await updateShoppingList(userId, updatedItems);
      setItems(updatedItems);
    } catch (err) {
      setError(err);
    }
  };

  const addItems = async (newItems) => {
    if (!userId) return;

    try {
      const updatedItems = [...items, ...newItems];

      await updateShoppingList(userId, updatedItems);
      setItems(updatedItems);
      return true;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  return (
    <ShoppingListContext.Provider
      value={{
        items: items.filter((item) => !!item),
        setItems,
        generatedItems,
        setGeneratedItems,
        loading,
        error,
        updateItem,
        deleteItem,
        saveItems,
        addItems,
      }}
    >
      {children}
    </ShoppingListContext.Provider>
  );
};
